import { DeleteOutlined, FilePdfOutlined } from '@ant-design/icons';
import { Button, Flex, Typography } from 'antd';
import { filesize } from 'filesize';
import type React from 'react';
import { useNewsClassNames } from './News.styles.ts';

export const AttachmentEntry: React.FC<{
  filename: string;
  size: number;
  onPreview: () => void;
  onDelete: () => void;
}> = ({ filename, size, onPreview, onDelete }) => {
  const classNames = useNewsClassNames();

  return (
    <Flex gap="small" align="center" justify="space-between" className={classNames.attachmentEntry}>
      <Flex gap="small" align="center">
        <FilePdfOutlined />
        <a className={classNames.pdfLink} onClick={onPreview}>
          {filename}
        </a>
        <Typography.Text type="secondary" className={classNames.nowrap}>
          ({filesize(size, { locale: 'de' })})
        </Typography.Text>
      </Flex>
      <Button icon={<DeleteOutlined />} danger type="text" onClick={onDelete} />
    </Flex>
  );
};
